import { render, staticRenderFns } from "./Dropdowns.vue?vue&type=template&id=512483a2&"
import script from "./Dropdowns.vue?vue&type=script&lang=js&"
export * from "./Dropdowns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Dropdowns.vue"
export default component.exports